// extracted by mini-css-extract-plugin
module.exports = {"reviews":"_3TM2NEG9xs3xzoS4DHCU4A==","list":"Y8qtlVBj6doLwg9CAR-WLw==","item":"HiXmujFlzVxK8+2q64k1nw=="};